import { useCallback, useState, type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchInput } from '@fastnorth/kraken/components/input';
import { Div } from '@fastnorth/kraken/components/layout';
import { H3, Text } from '@fastnorth/kraken/components/typography';

export type RaceProgressParticipantLookupSectionProps = {
  awaitingRaces?: boolean;
};

const RaceProgressParticipantLookupSection = ({
  awaitingRaces = false,
}: RaceProgressParticipantLookupSectionProps): ReactElement => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.event_progress_v2' });
  const [phrase, setPhrase] = useState('');
  const searchValue: string = awaitingRaces ? '' : phrase;

  const handleSearch = useCallback(
    (value: string) => {
      if (awaitingRaces) {
        return;
      }
      setPhrase(value);
    },
    [awaitingRaces]
  );

  const handleClear = useCallback(() => {
    setPhrase('');
  }, []);

  return (
    <Div data-testid="race-progress-participant-lookup">
      <H3 fontWeight="semibold" size="lg" spacing="0 0 4">
        {t('participant_lookup_heading')}
      </H3>
      <Div data-testid="race-progress-participant-lookup-search">
        <SearchInput
          ariaLabelClear={t('participant_lookup_clear')}
          debounceMillis={700}
          disabled={awaitingRaces}
          hideLabel
          id="race-progress-participant-lookup"
          label={{ children: t('participant_lookup_heading') }}
          onClear={handleClear}
          onSearch={handleSearch}
          placeholder={t('participant_lookup_placeholder')}
          value={searchValue}
          width="full"
        />
      </Div>
      {awaitingRaces ? (
        <Div spacing="4 0 0">
          <Text
            color="muted"
            data-testid="race-progress-participant-lookup-awaiting-races"
            size="sm">
            {t('participant_lookup_turns_on_once_races_loaded')}
          </Text>
        </Div>
      ) : null}
    </Div>
  );
};

export default RaceProgressParticipantLookupSection;
